/* eslint-disable */
import React, { useRef, useState, Suspense, useEffect, useCallback } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
// import { VEB_Plan } from "../../../../../../@types/plan.types";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { Button, Grid, IconButton, MenuItem } from "@mui/material";
import {
	Box,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Skeleton,
	Slider,
	TextField,
	Typography
} from "@mui/material";
// import { Button } from "@material-ui/core";
import { Code } from "@material-ui/icons";
import { BsCalendarMonth } from "react-icons/bs";
import ImageOutlinedIcon from "@material-ui/icons/ImageOutlined";
import PlanHeader from "../../../../../../shared/enrollment/planCode/PlanHeader";
import { VEB_Plan } from "../../../../../../../@types/plan.types";
// import PlanHeader from "../../../../../shared/enrollment/planCode/PlanHeader";

type Props = {
	open: boolean;
	initialBannerSrc?: string;
	initialLogoSrc?: string;
	initialData?: PlanDesignFormData;
	mode?: "view" | "edit" | "add";
	plan: any;
	onClose: () => void;
	onSubmit?: (data: PlanDesignFormData) => void;
};
export interface PlanDesignFormData {
	group_number: number;
	plan_name: string;
	plan_code: string;
	branding_design: {
		logo?: File | null;
		image?: File | null;
		textual_details: string;
	};
	form_design: {
		textual_details: string;
		form_declaration: string;
	};
}

const EditableBrandingPlain: React.FC<Props> = ({
	open,
	initialBannerSrc = "",
	initialLogoSrc = "",
	initialData,
	mode = "add",
	plan,
	onClose,
	onSubmit
}) => {
	const [banners, setBanners] = useState<string[]>(initialBannerSrc ? [initialBannerSrc] : []);

	// const [currentIndex, setCurrentIndex] = useState<number>(0);
	// console.log("initialData 2", initialBannerSrc, initialLogoSrc);
	const [logo, setLogo] = useState<string>(initialLogoSrc);
	const [formText, setFormText] = useState<string>("");
	const bannerInputRef = useRef<HTMLInputElement | null>(null);
	const [textualDetails, setTextualDetails] = useState<string>("");
	const [declaration, setDeclaration] = useState<string>("");
	const [description, setDescription] = useState<string>("");
	const [showSkeleton, setShowSkeleton] = useState<boolean>(true);
	const [isBending, setIsBranding] = useState<boolean>(false);
	const [showLogoSkeleton, setShowLogoSkeleton] = useState(false);
	const [isView, setIsView] = useState<boolean>(false);
	// const [logo, setLogo] = useState<string>("");
	const logoInputRef = useRef<HTMLInputElement | null>(null);
	const [formData, setFormData] = useState<PlanDesignFormData>(
		initialData || {
			group_number: plan.group_number || 0,
			plan_name: plan.plan_name,
			plan_code: plan.plan_code,
			branding_design: {
				logo: null,
				image: null,
				textual_details: ""
			},
			form_design: {
				textual_details: "",
				form_declaration: ""
			}
		}
	);

	const handleLogoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const file = e.target.files?.[0];
		if (!file) return;

		setShowLogoSkeleton(true);
		setFormData((prev) => ({
			...prev,
			branding_design: {
				...prev.branding_design,
				logo: file
			}
		}));
		const reader = new FileReader();
		reader.onload = () => {
			setLogo(reader.result as string);
			setShowLogoSkeleton(false); // stop when loaded
		};
		reader.readAsDataURL(file);
	};

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { name, value } = e.target;
		setFormData((prev) => ({
			...prev,
			[name]: name === "group_number" ? Number(value) : value
		}));
	};

	const handleBannerChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		if (showSkeleton) setShowSkeleton(false);

		const file = e.target.files?.[0];
		if (!file) return;

		// 1️⃣ Store the file itself for uploading later
		setFormData((prev) => ({
			...prev,
			branding_design: {
				...prev.branding_design,
				image: file
			}
		}));

		const url = URL.createObjectURL(file);
		setBanners([url]);
		setShowSkeleton(false);
	};

	// ✅ Corrected function names and parameter spelling
	const handleDeclarationChange = (value: string) => {
		setFormData((prev) => ({
			...prev,
			form_design: {
				...prev.form_design,
				form_declaration: value
			}
		}));
	};

	const handleDescriptionChange = (value: string) => {
		setDescription(value);

		// 🔹 Also update inside formData.form_design.textual_details
		setFormData((prev) => ({
			...prev,
			form_design: {
				...prev.form_design,
				textual_details: value
			}
		}));
	};

	const handleimagedetails = (value: string) => {
		setTextualDetails(value);

		setFormData((prev) => ({
			...prev,
			branding_design: {
				...prev.branding_design,
				textual_details: value
			}
		}));
	};
	const handleisBending = () => {
		if (banners && textualDetails) {
			setIsBranding(true);

			// console.log("Saving branding:", { banners, logo, textualDetails, formText });
		} else {
			alert("Please upload all the required items.");
		}
	};

	const handleSave = () => {
		if (formData?.group_number == null) {
			return;
		}
		// console.log("Saving branding:", { banners, logo, textualDetails, formText, declaration, description });
		// console.log("initialData", formData);
		// if (
		// 	!(formData.branding_design.image as any)?.originalname &&
		// 	(initialData?.branding_design.image as any)?.originalname
		// ) {
		// 	formData.branding_design["image"] = initialData?.branding_design.image;
		// }
		// if (
		// 	!(formData.branding_design.logo as any)?.originalname &&
		// 	(initialData?.branding_design.logo as any)?.originalname
		// ) {
		// 	formData.branding_design["logo"] = initialData?.branding_design.logo;
		// }
		onSubmit?.(formData);
		onClose();
	};
	const handleback = () => {
		setIsBranding(false);
	};

	const modules = { toolbar: { container: "#toolbar-container" } };
	const formats = [
		"font",
		"size",
		"header",
		"bold",
		"italic",
		"underline",
		"strike",
		"script",
		"color",
		"background",
		"align",
		"direction",
		"list",
		"bullet",
		"indent",
		"blockquote",
		"code",
		"code-block",
		"link",
		"image",

		"formula",
		"clean"
	];
	useEffect(() => {
		if (initialData) {
			const isView = mode === "view";
			// if (isView || mode === "edit") {
			// 	console.log("initialData in useEffect", initialData);
			// 	setFormData(initialData.planDesign ? initialData.planDesign : initialData);
			// } else {

			// console.log("initialData", initialData);

			if (initialData?.branding_design.image && initialBannerSrc.length > 0) {
				setBanners([initialBannerSrc]);
				setShowSkeleton(false);
			}
			if (initialData?.branding_design.textual_details) {
				setTextualDetails(initialData.branding_design.textual_details);
			}

			if (initialData?.branding_design.logo && initialLogoSrc.length > 0) {
				setLogo(initialLogoSrc);
				setShowLogoSkeleton(false);
			}
			setFormData(initialData);

			// }
			setIsView(isView);
		}
	}, [initialData, initialBannerSrc, initialLogoSrc, mode]);

	return (
		<Dialog
			open={open}
			onClose={onClose}
			fullWidth
			maxWidth={false}
			PaperProps={{
				sx: {
					// ✅ Center the dialog perfectly
					margin: "auto",
					top: "50%",
					left: "50%",
					transform: "translate(-50%, -50%)",
					position: "fixed",

					// ✅ Restrict the size properly
					width: "62vw",
					height: "90vh",
					borderRadius: 2,
					backgroundColor: "#E3E1E1",

					// ✅ Prevent scrollbars on the dialog itself
					overflow: "hidden"
				}
			}}
		>
			{/* ---------- FLOATING TOOLBAR ---------- */}
			<div
				id="toolbar-container"
				className="floating-toolbar"
				style={{
					top: 6,
					left: 10,
					zIndex: 1000,
					display: "flex",
					flexWrap: "wrap",
					gap: 6,
					padding: 4,
					background: "#fff",
					borderRadius: 8,
					boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
					maxHeight: "80%",
					justifyContent: "center",
					alignItems: "center"
				}}
			>
				<button className="ql-bold"></button>
				<button className="ql-italic"></button>
				<button className="ql-underline"></button>
				<button className="ql-strike"></button>
				<button className="ql-script" value="sub"></button>
				<button className="ql-script" value="super"></button>
				<select className="ql-size"></select>
				<select className="ql-color"></select>
				<select className="ql-background"></select>
				<select className="ql-align"></select>
				<button className="ql-direction" value="rtl"></button>
				<button className="ql-list" value="ordered"></button>
				<button className="ql-list" value="bullet"></button>
				<button className="ql-indent" value="-1"></button>
				<button className="ql-indent" value="+1"></button>
				<button className="ql-blockquote"></button>
			</div>

			{/* ---------- TITLE ---------- */}
			<DialogTitle
				style={{
					// marginTop: "-10px",
					textAlign: "center",
					fontWeight: 700,
					color: "#111",
					fontSize: "1.4rem",
					borderBottom: "1px solid #E0E0E0",
					backgroundColor: "#fff",
					boxShadow: "0 4px 14px rgba(0,0,0,0.25)",
					marginTop: "10px",
					borderRadius: 10,
					width: "100%"
				}}
			>
				Create Your Branding Page
			</DialogTitle>

			{/* ---------- MAIN CONTENT ---------- */}
			<DialogContent
				dividers
				sx={{
					// ✅ Make content scrollable inside
					overflowY: "auto",
					overflowX: "hidden",
					maxHeight: "calc(90vh - 120px)", // adjust if title/buttons are taller

					// ✅ Hide scrollbars visually but keep scroll working
					"&::-webkit-scrollbar": { display: "none" },
					scrollbarWidth: "none",
					msOverflowStyle: "none"
				}}
			>
				{/* ---------- PLAN DETAILS ---------- */}
				<Box
					sx={{
						backgroundColor: "#FFFFFF",
						borderRadius: "8px",
						padding: "12px 12px",
						display: "flex",
						flexDirection: "column",
						gap: 1,
						// marginTop: 2,

						boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
						width: "100%",
						marginTop: "20px"
						// backgroundColor: "green"
					}}
				>
					<Box
						sx={{
							display: "flex",
							flexDirection: "column",
							alignItems: "start",
							padding: 3,
							minHeight: "12vh",
							// marginTop: 2,
							width: "100%",
							borderRadius: "8px",
							overflow: "hidden",

							// height: { md: "calc(65vh * 0.55)" },
							// minHeight: "40vh",
							position: "relative",
							backgroundColor: "#fff"
						}}
					>
						<PlanHeader planCode={plan.plan_code} planName={plan.plan_name} />
					</Box>

					<Box
						sx={{
							display: "flex",
							flexDirection: "column",
							alignItems: "start",
							padding: 3,
							maxHeight: "65vh",
							marginTop: 2,
							width: "100%",
							borderRadius: "8px",
							overflow: "hidden",
							height: { md: "calc(65vh * 0.55)" },
							minHeight: "10vh",
							position: "relative",
							backgroundColor: "#fff"
						}}
					>
						{/* ✅ Logo section — placed at the top inside the main box */}

						<div
							style={{
								width: "120px",
								height: "40px",
								borderRadius: "6px",
								backgroundColor: "#ffff",
								minWidth: "100px",
								maxWidth: "20vw",
								cursor: "pointer",
								overflow: "hidden",
								flexShrink: 0,
								marginLeft: "5px",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								position: "relative" // Needed for skeleton overlay
							}}
							onClick={(e) => {
								e.stopPropagation();
								logoInputRef.current?.click();
							}}
						>
							{logo ? (
								<img
									src={logo}
									alt="Logo"
									style={{
										width: "100%",
										height: "100%",
										objectFit: "contain",
										opacity: showLogoSkeleton ? 0.5 : 1,
										transition: "opacity 0.3s ease",
										zIndex: 1000
									}}
									onLoad={() => setShowLogoSkeleton(false)} // stop skeleton when image loaded
								/>
							) : (
								<div
									style={{
										color: "#888",
										fontSize: "13px",
										textAlign: "center",
										padding: "20px",
										zIndex: 1000,
										backgroundColor: "#E2E0E0",
										borderRadius: "10px",

										boxShadow: `
									  -2px -2px 6px rgba(0,0,0,0.05),
									  8px 0 12px rgba(0,0,0.5,0.45),
									  0 4px 10px rgba(0,0,0,0.05)
									`
									}}
								>
									Upload Logo
								</div>
							)}

							{/* Hidden input */}
							<input
								ref={logoInputRef}
								type="file"
								accept="image/*"
								onChange={handleLogoChange}
								style={{ display: "none" }}
							/>
						</div>

						{/* ✅ Banner + Text arranged in a row */}
						<Box
							sx={{
								display: "flex",
								flexDirection: { xs: "column", sm: "column", md: "row" },
								alignItems: "stretch",
								flexShrink: 0,
								justifyContent: "flex-start",
								width: "100%",
								gap: 2
							}}
						>
							{/* ---------- LEFT: Banner ---------- */}
							<div
								style={{
									flex: "1 1 55%",
									minHeight: "150px",
									flexDirection: "column",
									// flex: "0 0 350px",
									position: "relative",
									maxHeight: "60%",
									maxWidth: "350px",
									minWidth: "350px",
									height: "75%",
									overflow: "hidden",
									display: "flex",
									borderRadius: "12px",
									alignItems: "start",
									justifyContent: "start",
									cursor: "pointer",
									backgroundColor: "#FAFAFA",

									boxShadow: `
									  -2px -2px 6px rgba(0,0,0,0.05),
									  8px 0 12px rgba(0,0,0.5,0.45),
									  0 4px 10px rgba(0,0,0,0.05)
									`
								}}
								onClick={() => bannerInputRef.current?.click()}
							>
								{banners.length === 0 ? (
									<span style={{ color: "#888", fontSize: 15 }}>Click to upload banner</span>
								) : (
									<>
										<img
											src={banners[0]}
											// alt={`banner-${currentIndex}`}
											style={{
												width: "100%",
												height: "100%",
												objectFit: "cover",
												transition: "transform 0.4s ease",
												boxShadow: "0 4px 14px rgba(0,0,0,35.65)"
											}}
										/>
										<div
											style={{
												position: "absolute",
												top: 0,
												right: 0,
												bottom: 0,
												width: "10%",
												background:
													"linear-gradient(to right, rgba(255,255,255,0) 0%, rgba(255,255,255,0.9) 100%)"
											}}
										/>
									</>
								)}

								{showSkeleton && (
									<div
										style={{
											position: "absolute",
											inset: 0,
											display: "flex",
											flexDirection: "row",
											justifyContent: "flex-start",
											alignItems: "flex-start",
											zIndex: 1000,
											gap: "16px",
											padding: "10px",
											overflow: "hidden",
											backgroundColor: "rgba(0, 128, 0, 0.05)",
											boxShadow: `
				-4px 0 8px rgba(0,0,0,0.15),
				8px 0 12px rgba(0,0,0,0.25),
				0 4px 10px rgba(0,0,0,0.35)
			`,
											borderRadius: "8px"
										}}
									>
										{/* ✅ Centered Overlay Text (middle-right start) */}
										<div
											style={{
												position: "absolute",
												top: "50%",
												left: "45%",
												transform: "translate(-50%, -50%)",
												display: "flex",
												flexDirection: "column",
												alignItems: "center",
												justifyContent: "center",
												color: "#679",
												pointerEvents: "none"
											}}
										>
											<ImageOutlinedIcon
												style={{ fontSize: 48, marginBottom: "4px", opacity: 0.7 }}
											/>
											{"Click to upload banner"}
										</div>
									</div>
								)}

								<input
									ref={bannerInputRef}
									type="file"
									accept="image/*"
									onChange={handleBannerChange}
									style={{ display: "none" }}
								/>
							</div>

							{/* ---------- RIGHT: Text Editor ---------- */}
							<div
								style={{
									flex: "1 1 45%",
									// background: "#FFFFFF",
									padding: "8px 10px",
									display: "flex",
									flexDirection: "column",
									justifyContent: "center",

									maxWidth: "65%",
									maxHeight: "65%"

									// backgroundColor: "green"
								}}
							>
								<style>
									{`
					.no-border-quill .ql-toolbar.ql-snow,
					.no-border-quill .ql-container.ql-snow {
						border: none !important;
						box-shadow: none !important;
						background: transparent !important;
					}
					.no-border-quill .ql-editor {
						background: transparent !important;
						padding: 0 !important;
					}
					.no-border-quill .ql-editor img {
						max-height: 350px;
						object-fit: contain;
						display: block;
						margin: 0 auto;
					}
				`}
								</style>

								<ReactQuill
									className="no-border-quill"
									value={textualDetails}
									onChange={handleimagedetails}
									modules={modules}
									formats={formats}
									placeholder="enter your text here"
									theme="snow"
									style={{
										width: "90%",
										height: "300px",
										minHeight: "50px",
										maxHeight: "350px",
										border: "none",
										outline: "none",
										boxShadow: "none",
										background: "#FFFFFF",
										fontSize: "15px",
										fontFamily: "inherit",
										lineHeight: 1.5,
										color: "#333",
										overflow: "hidden",
										padding: "4px"
									}}
								/>

								{showSkeleton && (
									<Box
										sx={{
											position: "absolute",
											inset: 0,
											display: "flex",
											justifyContent: "flex-end", // push to right side
											alignItems: "center",
											backgroundColor: "#fafafa",
											zIndex: 2,
											overflow: "hidden",
											borderRadius: 2,
											p: 2
										}}
									>
										{/* Wrapper for right half skeletons */}
										<Box
											sx={{
												width: "50%", // start from middle to right
												height: "65%",
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												justifyContent: "center",
												gap: 1.2,
												pr: 2
											}}
										>
											{/* <Skeleton variant="text" width="70%" height={22} /> */}
											<Skeleton variant="text" width="85%" height={22} />
											<Skeleton variant="text" width="90%" height={22} />
											<Skeleton
												variant="rectangular"
												width="100%"
												height={140}
												sx={{ borderRadius: 1 }}
											/>
											<Skeleton variant="text" width="60%" height={20} />
											<Skeleton
												variant="rectangular"
												width="90%"
												height={80}
												sx={{ borderRadius: 1 }}
											/>
										</Box>

										{/* Centered overlay text */}
										<Typography
											sx={{
												position: "absolute",
												top: "45%",
												left: "75%", // slightly right side center
												transform: "translate(-50%, -50%)",
												color: "#78909C",
												fontSize: 15,
												fontWeight: 500,
												pointerEvents: "none",
												textAlign: "center",
												backgroundColor: "rgba(255,255,255,0.7)",
												px: 2,
												py: 0.5,
												borderRadius: 1,
												boxShadow: "0 1px 4px rgba(0,0,0,0.05)"
											}}
										>
											Enter your text here
										</Typography>
									</Box>
								)}
							</div>
						</Box>
					</Box>
					<Box
						sx={{
							display: "flex",
							justifyContent: { xs: "center", md: "flex-end" },
							alignItems: "flex-end",
							gap: 2,
							mt: 8,
							width: "100%",
							paddingBottom: "20px",
							marginRight: "70px",
							marginTop: "-10px"
						}}
					>
						<Button
							// color="secondary"
							size="small"
							sx={{
								height: "38px",
								width: { xs: "120px", sm: "150px", md: "185px" },
								"&:hover": {
									backgroundColor: "#BDBDBD"
								},
								backgroundColor: "#BDBDBD",
								borderRadius: "6px",
								color: "black"
							}}
						>
							Waive
						</Button>
						<Button
							// variant="contained"
							size="small"
							sx={{
								backgroundColor: "#D0021B",
								color: "white",
								height: "38px",
								width: { xs: "120px", sm: "150px", md: "185px" },
								borderRadius: "6px",
								"&:hover": {
									backgroundColor: "#D0021B" // same as original color, no darkening
								}
							}}
						>
							Enroll
						</Button>
					</Box>
				</Box>

				{/* ---------- BANNER + TEXT SECTION ---------- */}
				{isBending && (
					<Dialog
						open={isBending}
						onClose={() => setIsBranding(false)}
						fullWidth
						maxWidth={false} // allows custom width below
						PaperProps={{
							style: {
								margin: 0,
								width: "90vw",
								maxWidth: "1200px",
								maxHeight: "90vh",
								borderRadius: 12,
								backgroundColor: "#fafafa",
								boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
								display: "flex",
								flexDirection: "column",
								alignItems: "center",
								justifyContent: "flex-start"
							}
						}}
					>
						<DialogTitle
							sx={{
								textAlign: "center",
								fontWeight: 700,
								color: "#111",
								fontSize: { xs: "1.2rem", sm: "1.4rem" },
								borderBottom: "1px solid #E0E0E0",
								backgroundColor: "#fff",
								boxShadow: "0 4px 14px rgba(0,0,0,0.15)",
								marginBottom: 3,
								borderRadius: 2,
								width: "100%",
								padding: "10px",
								marginTop: "10px"
							}}
						>
							Form Design Textual Details
						</DialogTitle>
						<Box
							style={{
								position: "absolute",
								top: 20,
								left: 20,
								zIndex: 1000,
								display: "flex",
								alignItems: "center",
								gap: "6px",
								backgroundColor: "rgba(255, 255, 255, 0.85)",
								borderRadius: "8px",
								padding: "6px 12px",
								// boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
								cursor: "pointer",
								transition: "all 0.3s ease"
							}}
							onClick={handleback}
							onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "rgba(76,175,80,0.15)")}
							onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.85)")}
						>
							<ArrowBackIosIcon
								style={{
									fontSize: "18px",
									color: "#4CAF50"
								}}
							/>
							<span
								style={{
									fontSize: "14px",
									fontWeight: 600,
									color: "#4CAF50",
									textTransform: "uppercase",
									letterSpacing: "0.5px"
								}}
							>
								Back
							</span>
						</Box>

						<DialogContent
							sx={{
								width: "100%",
								padding: 3,
								display: "flex",
								flexDirection: "column",
								alignItems: "center",
								backgroundColor: "#fff",
								borderRadius: 2,
								boxShadow: "inset 0 2px 8px rgba(0,0,0,0.05)"
							}}
						>
							<Box
								sx={{
									width: "94%", // consistent inner padding
									borderRadius: "8px",
									padding: "12px",
									display: "flex",
									flexDirection: "column",
									gap: 1,
									boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
									backgroundColor: "#fff"
								}}
							>
								<Grid
									container
									spacing={3}
									justifyContent="flex-start"
									alignItems="flex-start"
									sx={{
										flexDirection: "column",
										width: "100%"
									}}
								>
									<Grid item xs={12}>
										<Typography
											variant="subtitle1"
											sx={{
												fontWeight: 600,
												color: "#444",
												mt: 2,
												mb: 1
											}}
										>
											Description (Textual Details) <span style={{ color: "red" }}>*</span>
										</Typography>
									</Grid>
									<Grid
										item
										xs={12}
										sx={{
											width: "100%",
											overflow: "hidden", // prevent toolbar from scrolling
											"& .ql-container": {
												flex: 1,
												overflow: "hidden" // no scroll on container
											},
											"& .ql-editor": {
												overflowY: "auto !important", // ✅ scroll only the text area
												// maxHeight: "300px", // or whatever height you want
												padding: "8px 12px"
											}
										}}
									>
										<ReactQuill
											theme="snow"
											value={formData.form_design.textual_details}
											onChange={handleDescriptionChange}
											style={{
												width: "100%",
												minHeight: "220px",
												backgroundColor: "#fafafa",
												borderRadius: "10px",
												boxShadow: "inset 0 2px 6px rgba(0,0,0,0.1)",
												border: "none"
												// ".ql-editor": { overflow: "scroll" }
											}}
											modules={{
												toolbar: [
													[{ header: [1, 2, false] }],
													["bold", "italic", "underline", "strike", "blockquote"],
													[{ color: [] }, { background: [] }],
													[{ list: "ordered" }, { list: "bullet" }, { align: [] }],
													["link", "formula"],
													["clean"]
												]
											}}
										/>
									</Grid>
									{/* ---------------- Declaration Section ---------------- */}
									<Grid item xs={12}>
										<Typography
											variant="subtitle1"
											sx={{
												fontWeight: 600,
												color: "#444",
												mt: 2,
												mb: 1
											}}
										>
											Declaration (Textual Details)
										</Typography>
									</Grid>
									<Grid
										item
										xs={12}
										sx={{
											width: "100%",
											overflow: "hidden", // prevent toolbar from scrolling
											"& .ql-container": {
												flex: 1,
												overflow: "hidden" // no scroll on container
											},
											"& .ql-editor": {
												overflowY: "auto !important", // ✅ scroll only the text area
												maxHeight: "300px", // or whatever height you want
												padding: "8px 12px"
											}
										}}
									>
										<ReactQuill
											theme="snow"
											value={formData.form_design.form_declaration}
											onChange={handleDeclarationChange}
											style={{
												width: "100%",
												minHeight: "220px",
												backgroundColor: "#fafafa",
												borderRadius: "10px",
												boxShadow: "inset 0 2px 6px rgba(0,0,0,0.1)"
											}}
											modules={{
												toolbar: [
													[{ header: [1, 2, false] }],
													["bold", "italic", "underline", "strike", "blockquote"],
													[{ color: [] }, { background: [] }],
													[{ list: "ordered" }, { list: "bullet" }, { align: [] }],
													["link", "formula"],
													["clean"]
												]
											}}
										/>
									</Grid>
								</Grid>
							</Box>
						</DialogContent>

						<DialogActions sx={{ justifyContent: "flex-start", p: 2 }}>
							<Button
								onClick={onClose}
								variant="outlined"
								color="secondary"
								style={{ justifyContent: "flex-start" }}
							>
								Close
							</Button>

							{/* 🟩 Green Submit Button */}
							<Button
								onClick={() => {
									handleSave();
									setIsBranding(false);
									onClose();
								}}
								variant="contained"
								size="small"
								style={{
									backgroundColor: "#4CAF50",
									color: "white",
									height: "38px",
									width: "150px",
									borderRadius: "6px",
									fontWeight: 600,
									textTransform: "none"
								}}
							>
								Submit
							</Button>
						</DialogActions>
					</Dialog>
				)}
			</DialogContent>

			{/* ---------- ACTIONS ---------- */}
			<DialogActions sx={{ padding: "8px 16px", flexWrap: "wrap", justifyContent: "center" }}>
				<Button onClick={onClose} variant="outlined" color="secondary">
					Close
				</Button>

				<Button
					onClick={handleisBending}
					variant="contained"
					style={{ backgroundColor: "green", color: "white" }}
				>
					next
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default EditableBrandingPlain;
